import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
import { BRAND } from '../mock';
import { Button } from './ui/button';
import WebForm from './WebForm';

export default function Hero() {
  return (
    <section className="relative bg-[#4E4E50] overflow-hidden">
      {/* background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1641199788912-9a7385a35c82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxkZWxpdmVyeSUyMHZhbnxlbnwwfHx8fDE3ODk5MTc1NDd8MA&ixlib=rb-4.1.0&q=85"
          alt="StreetFleet courier delivery van in the city"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2f2f31]/95 via-[#3a3a3c]/85 to-[#4E4E50]/55" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5 text-white">
          <span className="inline-block bg-[#17A2C4] text-white text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full mb-5">
            Toronto &amp; GTA Courier
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] mb-5">
            Your city.<br />
            <span className="text-[#4FC3E0]">Delivered on time.</span>
          </h1>
          <p className="text-lg text-gray-200 max-w-xl mb-8">
            Same-Day, Rush, ASAP and After-Hours courier service across Toronto and the Greater Toronto Area. One call and a driver is on the way.
          </p>
          <div className="flex flex-wrap gap-3">
            <a href="#services">
              <Button className="bg-[#9BDDA0] hover:bg-[#86D08C] text-[#1f3b22] border-0 font-bold px-7 py-6 text-base gap-2">
                Our Services <ArrowRight size={18} />
              </Button>
            </a>
            <a href={BRAND.phoneHref}>
              <Button className="bg-[#17A2C4] hover:bg-[#128aa8] text-white border-0 font-bold px-7 py-6 text-base gap-2">
                <Phone size={18} /> {BRAND.phone}
              </Button>
            </a>
          </div>
        </div>

        {/* New-customer booking web form */}
        <div className="lg:col-span-7">
          <WebForm />
        </div>
      </div>
    </section>
  );
}
